/**
 * Utility function to subtract time from the start to minutes
 * @returns {Number}
 */
export const substractTimeFromStartToMinutes = function (time) {
    const topAction = this.actionsMap[this.topAction]
    if (topAction && topAction.startTime) {
        const difference =
            (new Date(time) - new Date(topAction.startTime)) /
            1000 /
            60
        return parseFloat(difference.toFixed(2))
    }
    return 0
}

/**
 * Method to initiate the estimation of a runbook
 */
export const startEstimateRunbook = function () {
    if (this.topAction) {
        const action = this.actionsMap[this.topAction]
        if (action) {
            action.potentialStartTime = 0
            return this.estimateAction(action)
        }
    }
    return 0
}

/**
 * Estimates the action's duration
 * @param action
 * @returns {Number}
 */
export const estimateAction = function (action) {
    const gapTime = this.calculateGapTime(action)
    action.potentialStartTime += gapTime
    let taskPotentialEndTime = this.setIndividualPotentialTimes(action)
    if (action.children?.length) {
        if (action.reverse) {
            let durations = action.children
                .map((childUid) => {
                    const child = this.actionsMap[childUid]
                    if (child) {
                        child.potentialStartTime = action.potentialStartTime
                        return this.estimateAction(child)
                    } else {
                        return 0
                    }
                })
                .filter((duration) => !!duration)
            if (taskPotentialEndTime !== null) {
                taskPotentialEndTime = Math.max(
                    taskPotentialEndTime,
                    ...durations
                )
            } else if (durations.length) {
                taskPotentialEndTime = Math.max(...durations)
            }
            if (taskPotentialEndTime) {
                action.potentialEndTime = taskPotentialEndTime
            }
        } else {
            let durations = action.children
                .map((childUid) => {
                    const child = this.actionsMap[childUid]
                    if (child) {
                        child.potentialStartTime = taskPotentialEndTime
                        return this.estimateAction(child)
                    } else {
                        return 0
                    }
                })
                .filter((duration) => !!duration)
            if (durations.length) {
                taskPotentialEndTime = Math.max(...durations)
            }
        }
    }
    if (action.nextSibling) {
        const nextSibling = this.actionsMap[action.nextSibling]
        if (nextSibling) {
            nextSibling.potentialStartTime = taskPotentialEndTime
            return this.estimateAction(nextSibling)
        }
    }
    return action.potentialEndTime
}

/**
 * Calculates the gap time between doNotStartBefore time and actual estimated duration
 * @param action
 * @returns {Number}
 */
export const calculateGapTime = function (action) {
    if (
        !action.doNotStartBeforeTime ||
        !this.runbook.runbookStartTime ||
        action.startTime
    ) {
        return 0
    }
    const timestamp = action.doNotStartBeforeTime.split(':')
    const timestampHours = parseInt(timestamp[0])
    const timestampMinutes = parseInt(timestamp[1])
    let doNotStartBeforeMinutes = timestampHours * 60 + timestampMinutes

    const runbookStartTime = new Date(this.runbook.runbookStartTime)
    const actionPotentialStartTimeMinutes =
        runbookStartTime.getHours() * 60 +
        runbookStartTime.getMinutes() +
        runbookStartTime.getSeconds() / 60 +
        action.potentialStartTime

    const runbookStartTimeMinutes =
        runbookStartTime.getHours() * 60 +
        runbookStartTime.getMinutes() +
        runbookStartTime.getSeconds() / 60
    if (runbookStartTimeMinutes > doNotStartBeforeMinutes) {
        doNotStartBeforeMinutes += 1440
    }

    // get total minutes between the times
    let minutes = doNotStartBeforeMinutes - actionPotentialStartTimeMinutes
    const hours = minutes / 60
    if (hours > 0) {
        return minutes
    } else {
        return 0
    }
}

/**
 * Calculates the potential end times and takes into account the DoNotStartBefore time
 * @param action
 * @returns {Number}
 */
export const setIndividualPotentialTimes = function (action) {
    if (action.parents?.length) {
        const parentEndTimes = action.parents
            .map((parentUid) => {
                const parent = this.actionsMap[parentUid]
                return parent?.potentialEndTime
            })
            .filter((endTime) => !!endTime)
        if (parentEndTimes?.length) {
            action.potentialStartTime = Math.max(...parentEndTimes)
        }
    }
    if (action.estimatedDuration) {
        if (action.startTime) {
            action.potentialStartTime = this.substractTimeFromStartToMinutes(
                action.startTime
            )
        }
        action.potentialEndTime =
            action.potentialStartTime + parseInt(action.estimatedDuration)
        if (action.endTime) {
            action.potentialEndTime = this.substractTimeFromStartToMinutes(
                action.endTime
            )
        }
    } else {
        action.potentialEndTime = action.potentialStartTime
    }
    return action.potentialEndTime
}
